import GoodsDetailCollapse from '@/components/GoodsDetail/GoodsDetailCollapse';
import { Box } from '@mui/material';
import { useTranslations } from '@/i18n/use-translations';

export default function HowItWorks() {
  const t = useTranslations('account.pointsMall.howItWorks');

  return (
    <GoodsDetailCollapse title={t('title')} defaultOpen>
      <Box className="mb-24">
        <p className="text-14 leading-[21px] font-ir">{t('steps.step1')}</p>
        <p className="text-14 mt-16 leading-[21px] font-ir">{t('steps.step2')}</p>
        <p className="text-14 mt-16 leading-[21px] font-ir">{t('steps.step3')}</p>
        <p className="text-14 mt-16 leading-[21px] font-ir">{t('steps.step4')}</p>
      </Box>
    </GoodsDetailCollapse>
  );
}
